import moment from 'moment';

export const dateFormat = 'MMM Do YYYY';

export const dateTimeFormat = 'MMM Do YYYY h:mma';

export function formatDate(date: string): string {
  return moment(date).format(dateFormat);
}

export function formatDateTime(dateTime: string): string {
  return moment(dateTime).format('MMM Do YYYY h:mma');
}
